const CLEAR_DELEGATION_HISTORY = 'CLEAR_DELEGATION_HISTORY';
const SET_DELEGATION_HISTORY = 'SET_DELEGATION_HISTORY';
const CHANGE_DELEGATION_HISTORY = 'CHANGE_DELEGATION_HISTORY';

const INIT_ALL_FILTERS = 'INIT_ALL_FILTERS';
const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
const RESET_FILTER_VALUES = 'RESET_FILTER_VALUES';
const APPLY_FILTERS = 'APPLY_FILTERS';

const SET_COUNT = 'SET_COUNT';

export const DELEGATION_HISTORY_TYPES = {
    CLEAR_DELEGATION_HISTORY,
    SET_DELEGATION_HISTORY,
    CHANGE_DELEGATION_HISTORY
};

export const DELEGATION_FILTERS_TYPES = {
    INIT_ALL_FILTERS,
    SET_FILTER_VALUE,
    RESET_FILTER_VALUES,
    APPLY_FILTERS
};

export const DELEGATION_PAGINATION_TYPES = {
    SET_COUNT
};